// BEE-158: Wraps public pages (sign-in, enroll, demo, privacy, about, join, welcome)
// with the global footer. Landing page is excluded — it manages its own footer.

import { Outlet } from 'react-router-dom'
import Footer from '@/components/landing/Footer'

export default function PublicLayout() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100dvh' }}>
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}
